/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-27 14:18:28
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 16:33:52
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/Menu/Components/MenuTree/index.tsx
 */
import classname from 'classnames';
import _ from 'lodash';
import React from 'react';
import css from './css.module.less';

import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { errCodesMap } from '@/src/error/code';
import { modal } from '@/src/utils/Modal';
import { get } from 'lodash';
import { Input, Modal } from 'src/components/Antd';
import LinkLibraryWithSisterScScope from 'src/constrains/LinkLibrary/LinkLibraryWithSisterScScope';
import MenuSortableTree from 'src/constrains/MenuSortableTree';
import {
  deleteNode,
  getNodes,
  modifyNode,
} from 'src/constrains/SortableTree/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { generateMenuItem } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/common';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';

const MenuTree = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [visible, setVisible] = React.useState(false);
  const [selectedMenu, setSelectedMenu] = React.useState(null);
  const {
    data,
    onChange,
    onAdd,
    salesChannelContentUuid,
    errorList,
    multiLanguageDisabled,
    linkSet,
    disableEdit,
  } = props;

  const occupiedName = React.useMemo(() => {
    const nodes = getNodes(data);
    return nodes.map((i) => {
      return i.title;
    });
  }, [data]);

  React.useEffect(() => {
    if (!visible && selectedMenu) {
      setSelectedMenu(null);
    }
  }, [visible]);

  const handleOnModalCancel = () => {
    setVisible(false);
  };

  const handleOnModalOk = (node) => {
    const tree = modifyNode(data, node);
    if (tree) {
      if (onChange) {
        onChange(tree);
      }
    } else {
      //add menu
      if (onAdd) {
        onAdd(node);
      }
    }
    handleOnModalCancel();
  };

  const handleOnTreeEdit = (node) => {
    setSelectedMenu(node);
    setVisible(true);
  };
  const handleOnTreeDelete = (node) => {
    modal.error({
      title: getI18n('salesChannelContent.index.deletemenuitem'),
      content: getI18n('salesChannelContent.index.deletemenuitemcontent'),
      onOkText: getI18n('general.delete'),
      onCancelText: getI18n('general.cancel'),
      onCancel: () => {
        return;
      },
      onOk: () => {
        const tree = deleteNode(data, node);
        if (onChange) {
          onChange(tree);
        }
      },
    });
  };
  const handleOnTreeAdd = () => {
    const node = generateMenuItem();
    setSelectedMenu(node);
    setVisible(true);
  };

  return (
    <div className={css.sortableTreeContainer}>
      {visible && (
        <_Modal
          hideLink={multiLanguageDisabled}
          occupiedName={occupiedName}
          visible={visible}
          salesChannelContentUuid={salesChannelContentUuid}
          onOk={handleOnModalOk}
          onCancel={handleOnModalCancel}
          data={selectedMenu}
          linkSet={linkSet}
        />
      )}
      {Array.isArray(errorList) && errorList.length !== 0 && (
        <div className={classname('errText', css.errorDisplay)}>
          {errorList
            .map((err) => (errCodesMap[err] ? errCodesMap[err] : err))
            .join('')}
        </div>
      )}
      <MenuSortableTree
        {...(!multiLanguageDisabled
          ? { onDelete: handleOnTreeDelete, onAdd: handleOnTreeAdd }
          : {})}
        onEdit={handleOnTreeEdit}
        // onDelete={handleOnTreeDelete}
        // onAdd={handleOnTreeAdd}
        data={data}
        onChange={onChange}
        multiLanguageDisabled={multiLanguageDisabled}
        disableEdit={disableEdit}
      />
    </div>
  );
};
export default MenuTree;

const _Modal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    visible,
    onCancel,
    onOk,
    data,
    linkId,
    occupiedName = [],
    salesChannelContentUuid,
    hideLink,
    // linkSet,
  } = props;
  const { title: _t, linkModule: _l } = data || {};

  const [title, setTitle] = React.useState(_t);
  const [linkModule, setLinkModule] = React.useState(_l);

  const handleOnOk = () => {
    if (onOk) {
      onOk({ ...(data || {}), title, linkModule });
    }
    onCancel();
  };

  const isNameOccupied = React.useMemo(() => {
    const arr = _.cloneDeep(occupiedName);
    _.remove(arr, (n) => {
      return n === _t;
    });

    return !!arr.find((i) => i === title);
  }, [title, occupiedName, _t]);
  const linkType = get(linkModule, 'linkType');

  return (
    <Modal
      onCancel={onCancel}
      width={600}
      visible={visible}
      title={
        _t
          ? getI18n('salesChannelContent.index.editMenuItem')
          : getI18n('salesChannelContent.index.addMenuItem')
      }
      footer={null}>
      <div className={css.modalContainer}>
        <ItemWrapper
          title={`${getI18n('general.customer.title')}*`}
          rightPart={<CountWords count={(title || '').length} allCount={30} />}>
          <Input
            error={isNameOccupied}
            help={getI18n('salesChannelContent.index.titleisOccupied')}
            maxLength={30}
            size='large'
            value={title}
            onChange={setTitle}
          />
        </ItemWrapper>
        {!hideLink && (
          <LinkLibraryWithSisterScScope
            hideTitle
            mode={'no-modal'}
            noModalHeader={<div>{getI18n('general.link')}*</div>}
            data={linkModule}
            onChange={setLinkModule}
            id={linkId || 'MenuItemLinkSelect'}
            salesChannelContentUuid={salesChannelContentUuid}
          />
        )}
      </div>
      <ModalFooter
        onCancel={onCancel}
        okText={getI18nFromGeneral('general.antd.Modal.ModalFooter.confirm')}
        cancelText={getI18nFromGeneral('general.commonHeader.discard_text')}
        onOk={handleOnOk}
        hideOkButton={!title || isNameOccupied || !linkType}
      />
    </Modal>
  );
};
